import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FileText, Eye, Loader2 } from "lucide-react";

export default function DocumentsModal({ user, onClose }) {
  const [docs, setDocs] = useState(null);
  const [opening, setOpening] = useState(null);

  useEffect(() => {
    api.get(`/admin/users/${user.id}/documents`).then((r) => setDocs(r.data)).catch(() => setDocs([]));
  }, [user.id]);

  const open = async (d) => {
    setOpening(d.id);
    try {
      const r = await api.get(`/admin/documents/${d.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch { toast.error("Impossible d'ouvrir la pièce"); }
    finally { setOpening(null); }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="documents-modal">
        <DialogHeader><DialogTitle>Pièces justificatives — {user.pharmacy_name || user.supplier_name || user.name}</DialogTitle></DialogHeader>
        {docs === null ? <Loader2 className="h-5 w-5 animate-spin text-indigo-600" /> : docs.length === 0 ? (
          <p className="text-sm text-slate-500" data-testid="documents-empty">Aucune pièce déposée par ce membre.</p>
        ) : (
          <div className="space-y-2">
            {docs.map((d) => (
              <div key={d.id} className="flex items-center gap-3 rounded-lg border border-slate-200 px-3 py-2.5" data-testid={`document-${d.id}`}>
                <FileText className="h-5 w-5 text-indigo-600 shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-slate-900">{d.doc_label}</div>
                  <div className="text-xs text-slate-400 truncate">{d.original_filename} · {fmtDate(d.created_at)}</div>
                </div>
                <button onClick={() => open(d)} disabled={opening === d.id} data-testid={`document-open-${d.id}`}
                  className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-indigo-50 text-indigo-700 hover:bg-indigo-100 text-xs font-semibold transition-colors duration-200 disabled:opacity-60">
                  {opening === d.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Eye className="h-3.5 w-3.5" />} Ouvrir
                </button>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
